import { render, staticRenderFns } from "./StartForm.vue?vue&type=template&id=1e2c463d&"
import script from "./StartForm.vue?vue&type=script&lang=js&"
export * from "./StartForm.vue?vue&type=script&lang=js&"
import style0 from "./StartForm.vue?vue&type=style&index=0&id=1e2c463d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports